export default "__VITE_ASSET__Br0_ftLe__"